import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'
import Switch from 'react-switch';

// helpers
import { showMessage } from "../../helpers/message.js";

// api
import usuario_api from "../../api/usuario_api.js";
import concessionaria_api from "../../api/concessionaria_api.js";
import formulariovistoria_api from "../../api/formulariovistoria_api.js";

export default function UsuarioFicha({ item, handleReturn }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    const [isDisable, set_isDisable] = useState(true);

    // Status
    const options_status = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" }
    ];
    const [status, set_status] = useState(null);
    const handleChangeStatus = (value) => {
        set_status(value);
        clearErrors("status");
        setValue("status", value, true);
    }

    // Perfil
    const [options_perfil, set_options_perfil] = useState([]);
    const loadOptionsPerfis = () => {
        usuario_api.getPerfisCadastro().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _perfis = [];
                result.data.map((m) => _perfis.push({ label: m, value: m }));
                set_options_perfil(_perfis);
            }
        });
    }
    const [perfil, set_perfil] = useState(null);
    const handleChangePerfil = (value) => {
        set_perfil(value);
        clearErrors("perfil");
        setValue("perfil", value, true);

        loadOptionsFuncionalidades(value);

        if ((value == "Concessionária" || value == "Gestor" || value == "Agente Fiscalizador") && options_concessionaria.length == 0) {
            loadOptionsConcessionarias();
        }

        if (options_formularios.length == 0)
            loadOptionsFormularios();
    }

    // Concessionária (perfil Concessionária — vínculo único)
    const [options_concessionaria, set_options_concessionaria] = useState([]);
    const loadOptionsConcessionarias = () => {
        concessionaria_api.getAll().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_concessionaria(result.data);
            }
        })
    }
    const [concessionaria, set_concessionaria] = useState(null);
    const handleChangeConcessionaria = (value) => {
        set_concessionaria(value);
        setValue("concessionaria", value, true);
        clearErrors("concessionaria");
    }

    // Concessionárias (perfil Gestor / Agente Fiscalizador — múltiplos vínculos)
    const opcao_todas_concessionarias = { concessionaria_Id: "TODAS", identificacao: "Todas" };
    const [concessionarias, set_concessionarias] = useState([]);
    const normalizarConcessionarias = (vinculos) => (vinculos || []).map(m => ({
        usuarioConcessionaria_Id: m.usuarioConcessionaria_Id,
        usuario_Id: m.usuario_Id,
        concessionaria_Id: m.concessionaria_Id
    }));
    const handleChangeConcessionarias = (value) => {
        if (value && value.some(v => v.concessionaria_Id == "TODAS")) {
            handleSelecionarTodasConcessionarias();
            return;
        }

        let _concessionarias = [];
        if (value)
            value.map(m => {
                _concessionarias.push({
                    concessionaria_Id: m.concessionaria_Id,
                    usuario_Id: item != null ? item.usuario_Id : 0,
                    usuarioConcessionaria_Id: item != null ? item.usuarioConcessionarias.filter(f => f.concessionaria_Id == m.concessionaria_Id)[0]?.usuarioConcessionaria_Id : 0
                });
            })

        set_concessionarias(_concessionarias);

        if (_concessionarias.length > 0) {
            setValue("concessionarias", _concessionarias, true);
            clearErrors("concessionarias");
        }
        else {
            setValue("concessionarias", undefined, false);
        }
    }
    const handleSelecionarTodasConcessionarias = () => {
        let _concessionarias = [];

        options_concessionaria.map(m => {
            _concessionarias.push({
                concessionaria_Id: m.concessionaria_Id,
                usuario_Id: item != null ? item.usuario_Id : 0,
                usuarioConcessionaria_Id: item != null ? item.usuarioConcessionarias.filter(f => f.concessionaria_Id == m.concessionaria_Id)[0]?.usuarioConcessionaria_Id : 0
            });
        })

        set_concessionarias(_concessionarias);
        setValue("concessionarias", _concessionarias, true);
        clearErrors("concessionarias");
    }

    // Formularios Vistoria
    const [options_formularios, set_options_formularios] = useState([]);
    const loadOptionsFormularios = () => {
        formulariovistoria_api.getAll().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_formularios(result.data);
            }
        })
    }
    const [formularios, set_formularios] = useState([]);
    const normalizarFormularios = (vinculos) => (vinculos || []).map(m => ({
        usuarioFormulario_Id: m.usuarioFormulario_Id,
        usuario_Id: m.usuario_Id,
        formularioVistoria_Id: m.formularioVistoria_Id
    }));
    const handleChangeFormularios = (value) => {
        let _formularios = [];
        if (value)
            value.map(m => {
                _formularios.push({
                    formularioVistoria_Id: m.formularioVistoria_Id,
                    usuario_Id: item != null ? item.usuario_Id : 0,
                    usuarioFormulario_Id: item != null ? item.usuarioFormularios.filter(f => f.formularioVistoria_Id == m.formularioVistoria_Id)[0]?.usuarioFormulario_Id : 0
                });
            })

        set_formularios(_formularios);

        if (_formularios.length > 0) {
            setValue("formularios", _formularios, true);
            clearErrors("formularios");
        }
        else {
            setValue("formularios", undefined, false);
        }
    }
    const handleSelecionarTodosFormularios = () => {
        let _formularios = [];

        options_formularios.map(m => {
            _formularios.push({
                formularioVistoria_Id: m.formularioVistoria_Id,
                usuario_Id: item != null ? item.usuario_Id : 0,
                usuarioFormulario_Id: item != null ? item.usuarioFormularios.filter(f => f.formularioVistoria_Id == m.formularioVistoria_Id)[0]?.usuarioFormulario_Id : 0
            });
        })

        set_formularios(_formularios);
        setValue("formularios", _formularios, true);
        clearErrors("formularios");
    }

    // Funcionalidades
    const [options_funcionalidades, set_options_funcionalidades] = useState([]);
    const loadOptionsFuncionalidades = (_perfil) => {
        usuario_api.getFuncionalidades(_perfil).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_funcionalidades(result.data);
            }
        });
    }
    const [usuarioFuncionalidadeAcoes, set_usuarioFuncionalidadeAcoes] = useState([]);
    const handleChangeFuncionalidadesAcoes = (funcionalidadeAcao_Id, checked) => {
        let _acoesUsuario = usuarioFuncionalidadeAcoes.filter(f => f.funcionalidadeAcao_Id != funcionalidadeAcao_Id);
        if (checked) {
            _acoesUsuario.push({
                usuarioFuncionalidadeAcao_Id: item ? item.usuarioFuncionalidadeAcos.filter(f => f.funcionalidadeAcao_Id == funcionalidadeAcao_Id)[0]?.usuarioFuncionalidadeAcao_Id : 0,
                usuario_Id: item ? item.usuario_Id : 0,
                funcionalidadeAcao_Id: funcionalidadeAcao_Id
            });
        }

        set_usuarioFuncionalidadeAcoes(_acoesUsuario);
    }

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("Usuarios", "Editar").then((result) => { set_isDisable(!result); });

        loadOptionsPerfis();
        loadForm();
    }, []);

    const loadForm = () => {
        if (item != null) {
            setValue("login", item.login);
            setValue("nome", item.nome);
            setValue("email", item.email);
            set_status(item.status);
            setValue("status", item.status, true);
            set_perfil(item.perfil);
            setValue("perfil", item.perfil, true);

            if (item.perfil == "Concessionária" || item.perfil == "Gestor" || item.perfil == "Agente Fiscalizador") {
                loadOptionsConcessionarias();
            }

            if (item.perfil == "Concessionária") {
                let vinculo = (item.usuarioConcessionarias || [])[0];
                set_concessionaria(vinculo ? vinculo.concessionaria : null);
                setValue("concessionaria", vinculo ? vinculo.concessionaria : null);
            }

            let _concessionariasVinculadas = normalizarConcessionarias(item.usuarioConcessionarias);
            set_concessionarias(_concessionariasVinculadas);
            setValue("concessionarias", _concessionariasVinculadas.length > 0 ? _concessionariasVinculadas : undefined, true);

            loadOptionsFormularios();
            let _formulariosVinculados = normalizarFormularios(item.usuarioFormularios);
            set_formularios(_formulariosVinculados);
            setValue("formularios", _formulariosVinculados.length > 0 ? _formulariosVinculados : undefined, true);

            loadOptionsFuncionalidades(item.perfil);
            set_usuarioFuncionalidadeAcoes(item.usuarioFuncionalidadeAcos);
        }
    }

    const onSubmit = (data) => {
        let usuarioConcessionarias = [];
        if (perfil == "Concessionária" && concessionaria) {
            usuarioConcessionarias = [{
                concessionaria_Id: concessionaria.concessionaria_Id,
                usuario_Id: item ? item.usuario_Id : 0,
                usuarioConcessionaria_Id: item ? item.usuarioConcessionarias?.filter(f => f.concessionaria_Id == concessionaria.concessionaria_Id)[0]?.usuarioConcessionaria_Id : 0
            }];
        }
        else if (perfil == "Gestor" || perfil == "Agente Fiscalizador") {
            usuarioConcessionarias = concessionarias;
        }

        let json_submit = {
            usuario_Id: item ? item.usuario_Id : 0,
            nome: data.nome,
            login: data.login,
            perfil: perfil,
            status: status,
            email: data.email,
            usuarioConcessionarias: usuarioConcessionarias,
            usuarioFormularios: formularios,
            usuarioFuncionalidadeAcos: usuarioFuncionalidadeAcoes
        };

        setshowLoading(true);
        if (json_submit.usuario_Id == 0)
            usuario_api.post(json_submit).then(result => handleReturnSubmit(result));
        else
            usuario_api.put(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">

                <Row>
                    <Col md="12">
                        <Button color="default" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    </Col>
                </Row>
                <Card>
                    <CardHeader>
                        <h4 className="titleCard">Usuário</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col lg="3" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Login</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="login"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.login && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Nome</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="nome"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.nome && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Status</label>
                                        <Select
                                            name="status"
                                            options={options_status}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_status.filter(f => f.value == status)}
                                            onChange={(o) => handleChangeStatus(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "status" },
                                                { required: true })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Perfil</label>
                                        <Select
                                            name="perfil"
                                            options={options_perfil}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_perfil.filter(f => f.value == perfil)}
                                            onChange={(o) => handleChangePerfil(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "perfil" },
                                                { required: true })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.perfil && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Email</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="email"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <h5 className={(perfil == "Concessionária" || perfil == "Gestor" || perfil == "Agente Fiscalizador") ? "subtitleCard" : "d-none"}>Configurações da Concessionária</h5>
                            <Row className={perfil == "Concessionária" ? "" : "d-none"}>
                                <Col lg="6" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Concessionária</label>
                                        <Select
                                            name="concessionaria"
                                            options={options_concessionaria}
                                            getOptionLabel={o => o.identificacao}
                                            getOptionValue={o => o.concessionaria_Id}
                                            value={concessionaria}
                                            onChange={(o) => handleChangeConcessionaria(o)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "concessionaria" },
                                                { required: perfil == "Concessionária" })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.concessionaria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className={(perfil == "Gestor" || perfil == "Agente Fiscalizador") ? "" : "d-none"}>
                                <Col lg="12" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Concessionárias</label>
                                        <Select
                                            name="concessionarias"
                                            options={[opcao_todas_concessionarias, ...options_concessionaria]}
                                            getOptionLabel={o => o.identificacao}
                                            getOptionValue={o => o.concessionaria_Id}
                                            value={options_concessionaria.filter(({ concessionaria_Id }) => concessionarias.filter(f => f.concessionaria_Id == concessionaria_Id).length > 0)}
                                            onChange={(o) => handleChangeConcessionarias(o)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            isMulti={true}
                                            ref={e => register(
                                                { name: "concessionarias" },
                                                { required: perfil == "Gestor" || perfil == "Agente Fiscalizador" })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.concessionarias && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <h5 className={"subtitleCard"}>Configurações de Acesso aos Formulários</h5>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Formulários de Vistoria</label>
                                        <Select
                                            name="formularios"
                                            options={options_formularios}
                                            getOptionLabel={o => o.identificacao}
                                            getOptionValue={o => o.formularioVistoria_Id}
                                            value={options_formularios.filter(({ formularioVistoria_Id }) => formularios.filter(f => f.formularioVistoria_Id == formularioVistoria_Id).length > 0)}
                                            onChange={(o) => handleChangeFormularios(o)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            isMulti={true}
                                            ref={e => register(
                                                { name: "formularios" },
                                                { required: perfil === "Agente Fiscalizador" })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.formularios && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="12" md="12" sm="12">
                                    <Button className="btn-link" type="button" onClick={handleSelecionarTodosFormularios}>Selecionar Todos</Button>
                                </Col>
                            </Row>
                            <h5 className="subtitleCard">Lista de Permissões de Acesso</h5>
                            <Row>
                                {options_funcionalidades.map((m, key) => (
                                    <Col lg="3" md="6" sm="12" key={key}>
                                        <Card className="subcard">
                                            <CardHeader>{m.descricao}</CardHeader>
                                            <CardBody>
                                                <Row>
                                                    {
                                                        m.funcionalidadeAcos.map((n, key2) => (
                                                            <Col lg="12" md="12" sm="12" key={key2}>
                                                                <FormGroup>
                                                                    <label htmlFor={n.funcionalidadeAcao_Id}>
                                                                        <span>{n.acao}</span>
                                                                        <Switch
                                                                            id={n.funcionalidadeAcao_Id}
                                                                            className="react-switch"
                                                                            checked={usuarioFuncionalidadeAcoes.filter(f => f.funcionalidadeAcao_Id == n.funcionalidadeAcao_Id).length > 0}
                                                                            onChange={(checked) => handleChangeFuncionalidadesAcoes(n.funcionalidadeAcao_Id, checked)}
                                                                            onColor="#86d3ff"
                                                                            onHandleColor="#2693e6"
                                                                            disabled={isDisable}
                                                                        />
                                                                    </label>
                                                                </FormGroup>
                                                            </Col>
                                                        ))}
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                            {!isDisable &&
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <Button color="success" type="submit">
                                            <i className="fas fa-save"></i>  Salvar
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

